import PropTypes from 'prop-types';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLoading = ({
  message = 'default'
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    minHeight: 100
  }), /*#__PURE__*/_jsx(Text, {
    as: "h1",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `login.loading.${message}`
    })
  })]
});
LoginLoading.propTypes = {
  message: PropTypes.string
};
export default LoginLoading;